import React from "react";
import style from "./index.module.less";
import { useCountDown } from "ahooks";
import { processOssImage } from "@/utils/image";

const CountDown: React.FC<{
  bgUrl?: string;
  endTime: string;
}> = (props) => {
  const { bgUrl, endTime } = props;

  const [countdown, formattedRes] = useCountDown({
    targetDate: endTime,
  });
  const { days, hours, minutes, seconds } = formattedRes;

  return (
    <div className={style["countdown"]}>
      <span
        style={{
          backgroundImage: `url(${processOssImage(bgUrl)})`,
          backgroundSize: "100% 100%",
        }}
      >
        距离活动结束还剩:
        <span className={style["dateWidth"]}>{days || "00"}</span>天
        <span className={style["dateWidth"]}>{hours || "00"}</span>时
        <span className={style["dateWidth"]}>{minutes || "00"}</span>分
        <span className={style["dateWidth"]}>{seconds || "00"}</span>秒
      </span>
    </div>
  );
};

export default CountDown;
